import * as React from "react";
import { PortfolioComponent } from 'src/components/portfolioComponent';

export const Home = () => (
    <PortfolioComponent />
);